module.exports = __webpack_public_path__ + "static/media/img1.13cc1b80.jpg";